import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridToolbar,
} from "@mui/x-data-grid";
import { TabButton } from "../NOC.Tabs/Noc.styled";
import { DELINK } from "./../NOC.Tabs/Noc.styled";
import pdf from "../../assets/PdfIcon.svg";

import AccountsNotifications from "../../stores/AccountsNotificationsStore";
import User from "../../stores/UserStore";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AccountsGridMobile from "./AccountsGridMobile";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { Spinner } from "../SpinnerRaw/SpinnerRaw";
import DeLinkAccountModal from './DeLinkAccount'
import Modal from "@mui/material/Modal";

const AccountGrid = (props: any) => {
  const [pageSize, setPageSize] = useState<number>(6);
  const [loading, setLoading] = useState(false);
  const [deLinkModal, setDeLinkModal] = useState(false);
  const [accountNo, setAccountNo] = useState('');

  const [rows, setRows] = useState<Object[]>([]);

  const navigate = useNavigate();

  const dowmloadPDF = async (id: string) => {
    setLoading(true);
    const res = await AccountsNotifications.downloadEDCBill({ errorId: "getFileError", data: id });
    if (res) {
      setLoading(false)
    }
  };

  const loadTable = async () => {
    setLoading(true);
    try {
      // Wait for both getMyAccounts and getConnectedAccounts to finish
      await Promise.all([
        AccountsNotifications.getMyAccounts({
          errorId: "getMyAccountsError",
          data: User.info.personId as string,
        }),
        AccountsNotifications.getConnectedAccounts({
          errorId: "getConnectedAccountsError",
        })
      ]);

      const accounts = AccountsNotifications.accounts.map((account) => {
        return { ...account, localType: "normal" };
      });

      const connectedAccounts = AccountsNotifications.connectedAccounts.map(
        (account) => {
          return {
            ...account,
            localType: "con",
            sewerageNumber: account.sewerageId,
            accountNumber: account.accountId,
            premiseType: account.premiseUsage,
          };
        }
      );

      const data = [...connectedAccounts, ...accounts];

      const uniqueAccounts: any = {};
      const filteredData: any = [];

      data.forEach(obj => {
        if (!uniqueAccounts[obj.accountNumber]) {
          uniqueAccounts[obj.accountNumber] = obj.localType === "con";
          filteredData.push(obj);
        } else {
          if (obj.localType === "normal" && uniqueAccounts[obj.accountNumber]) {
            const existingObjIndex = filteredData.findIndex((item: any) => item.accountNumber === obj.accountNumber && item.localType === "con");
            if (existingObjIndex !== -1) {
              filteredData[existingObjIndex].localType = "con";
            }
          }
        }
      });

      setRows(filteredData);
    } catch (error) {
      console.error("Failed to load table data:", error);
      // Optionally, handle the error by showing a user-friendly message or performing other error recovery operations.
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    loadTable();
  }, []);

  const columns: GridColDef[] = [
    {
      field: "localType",
      headerName: "",
      hide: true,
    },
    {
      field: "accountNumber",
      headerName: General?.codeLabels['cm_accountid']?.label ? General?.codeLabels['cm_accountid']?.label : "Account Number",
      editable: false,
      flex: 1,
    },
    {
      field: "sewerageNumber",
      headerName: General?.codeLabels['cm_sewerageid']?.label ? General?.codeLabels['cm_sewerageid']?.label : "Sewerage Number",
      editable: false,
      flex: 1,
    },
    {
      field: "premiseDetails",
      headerName: General?.codeLabels['cm_pdc_premisedetails']?.label ? General?.codeLabels['cm_pdc_premisedetails']?.label : "Premise Details",
      headerAlign: "left",
      editable: false,
      flex: 1,
    },
    {
      field: "premiseType",
      headerName: General?.codeLabels["cm_premise_type"]?.label ? General?.codeLabels["cm_premise_type"]?.label : "Premise Type",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 1,
    },
    {
      field: "customerName",
      headerName: General?.codeLabels["cm_customername"]?.label ? General?.codeLabels["cm_customername"]?.label : "Customer Name",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 1,
    },
    {
      field: "Bill",
      headerName: General?.codeLabels["cm_last_bill"]?.label ? General?.codeLabels["cm_last_bill"]?.label : "Last Bill",
      headerAlign: "left",
      align: "center",
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            <div onClick={() => dowmloadPDF(params.row.accountNumber)}>
              <img style={{ cursor: 'pointer' }} src={pdf} alt="" />
            </div>
          </>
        );
      },
    },
    {
      field: "Delink",
      headerName: General?.codeLabels["cm_delink"]?.label ? General?.codeLabels["cm_delink"]?.label : "Delink Property",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params: any) => {
        return (
          <>
            {params.row.localType === "con" ? (
              <div onClick={() => {
                setAccountNo(params?.row?.sewerageNumber)
                setDeLinkModal(true)
              }}>
                <DELINK
                  style={{
                    backgroundColor: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "white",
                    border: 'none'
                  }}
                >
                  {General?.codeLabels["cm_delink_pd"]?.label ? General?.codeLabels["cm_delink_pd"]?.label : "DELINK"}
                </DELINK>
              </div>
            ) : null}
          </>
        );
      },
    },
  ];


  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div
      style={{
        height: "85vh"
      }}
    >

      <Box
        sx={{
          height: "90vh",
          width: props?.MyAccountsWidth ?? "90%",
          background: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
          margin: "auto",
        }}
      >
        <br />
        <div
          style={{
            width: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "end",
            paddingInlineEnd: General?.isLargeScreen ? '10px' : "",
            padding: General?.isLargeScreen ? "" : "1rem"
          }}
        >
          <TabButton
            onClick={() => navigate("/link-property")}
            style={{
              fontWeight: "900",
              height: "50px",
              width: isLargeScreen ? "192px" : "100%",
              fontSize: `${General.accessibility.fontSize}rem`,
              color: General.contrast.contrastColor
                ? General.contrast.contrastBackground
                : '#fff',
              background: General.contrast.contrastBackground
                ? General.contrast.contrastColor
                : General?.ColorAss,
              zIndex: '0',
            }}
          //className="DynamicButtonColor"
          >
            {General?.codeLabels["cm_link"]?.label ? General?.codeLabels["cm_link"]?.label : "LINK NEW PROPERTY"}
          </TabButton>
        </div>
        <br />
        {isLargeScreen ? (
          loading ? (
            <Spinner />
          ) : (
            <DataGrid
              getRowId={() => Math.floor(Math.random() * 100000000)}
              loading={loading}
              checkboxSelection={false}
              rows={rows}
              hideFooter={false} // Ensure footer is not hidden to show pagination controls
              columns={columns}
              disableSelectionOnClick={true}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              pagination // Enable pagination
              autoHeight // Remove vertical scroll by adjusting height dynamically
              sx={{
                "& .MuiDataGrid-columnSeparator": { display: "none" },
                border: props?.MyAccountsOutline ?? " ",
                color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                width: "90%",
                margin: "auto",
                "& .MuiDataGrid-cell, .MuiDataGrid-row": {
                  whiteSpace: "normal !important",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bolder !important",
                  fontSize: '1rem'
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "rgba(229, 239, 242, 0.7)",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                },
                "& .MuiSvgIcon-root": {
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                },
              }}
              rowHeight={80}
            />
          )
        ) : (
          <AccountsGridMobile 
          dowmloadPDF={dowmloadPDF}
          rowsss={rows} 
          loadTable={loadTable} />
        )}
      </Box>

      {!isLargeScreen ? <>{/* <AccountsGridMobile/> */}</> : ""}

      <Modal
        open={deLinkModal}
        onClose={() => setDeLinkModal(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DeLinkAccountModal accountNo={accountNo} getUser={loadTable} onCross={() => setDeLinkModal(false)} />
      </Modal>
    </div>
  );
};

export default observer(AccountGrid);
